import styled, { css, keyframes } from "styled-components";
import { designTokens } from "../ui/foundation/DesignTokens";

const fadeAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const CardWrapper = styled.article`
  width: 100%;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid ${designTokens.colors.gray[200]};
  padding: 24px;
  border-radius: ${designTokens.radius.lg};
  background-image: ${(props) => props.image ? `url(${props.image})` : 'none'};
  background-size: contain;
  background-position: bottom right;
  background-repeat: no-repeat;
  transition: all 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }
`;

export const CardTitle = styled.h3`
  font-family: ${designTokens.fonts.body};
  font-size: 0.875rem;
  font-weight: 500;
  color: ${designTokens.colors.gray[600]};
  margin-bottom: 12px;
  line-height: 1.4;
`;

export const CardNumber = styled.strong`
  display: block;
  font-family: ${designTokens.fonts.heading};
  font-size: 2rem;
  font-weight: 700;
  color: ${(props) => props.color || designTokens.colors.gray[900]};
  margin-bottom: 8px;
  line-height: 1.2;

  ${(props) =>
    props.isNewText &&
    css`
      opacity: 1;
      animation: ${fadeAnimation} 3s ease-in-out;
    `}
`;

export const CardText = styled.span`
  display: block;
  font-family: ${designTokens.fonts.body};
  font-size: 0.75rem;
  font-weight: 500;
  color: ${designTokens.colors.gray[500]};

  ${(props) =>
    props.isNewText &&
    css`
      opacity: 1;
      animation: ${fadeAnimation} 3s ease-in-out;
    `}
`;

// Sparkline container for mini charts
export const CardSparkline = styled.div`
  height: 40px;
  width: 100%;
  margin-top: 16px;

  svg {
    width: 100%;
    height: 100%;
  }
`;

// Icon container for card header
export const CardIconWrapper = styled.div`
  width: 40px;
  height: 40px;
  border-radius: ${designTokens.radius.md};
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${(props) => props.bgColor || 'rgba(79, 70, 229, 0.1)'};
  margin-bottom: 16px;

  svg {
    width: 20px;
    height: 20px;
    color: ${(props) => props.iconColor || '#4F46E5'};
  }
`;

// Change indicator (positive/negative)
export const CardChange = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-family: ${designTokens.fonts.body};
  font-size: 0.75rem;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: ${designTokens.radius.full};
  margin-top: 8px;

  ${(props) =>
    props.positive
      ? css`
          color: #059669;
          background: rgba(5, 150, 105, 0.1);
        `
      : css`
          color: #dc2626;
          background: rgba(220, 38, 38, 0.1);
        `}
`;
